<template>
  <div class="main">
    <div :id="bunnyId" :style="animations.animationPlayState"></div>
    <img
      class="egg egg-animation"
      :style="animations.animationPlayState"
      :src="require(`@/assets/practices/easter_egg/${eggName + concat}.svg`)"
      :alt="eggName"
      @click="eggEvent(eggAnswer)"
    />
    <div class="number egg-animation" :style="animations.animationPlayState" @click="eggEvent(eggAnswer)">
      {{ eggNumber }}
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { setTimeout } from 'timers';
// import { Howl } from 'howler';
import lottie from 'lottie-web/build/player/lottie';
import sounds from '@/packages/sounds/index.js';

export default {
  name: 'Egg',
  props: {
    // eslint-disable-next-line vue/require-default-prop
    eggNumber: Number,
    // eslint-disable-next-line vue/require-default-prop
    eggName: String,
    // eslint-disable-next-line vue/require-default-prop
    eggPath: String,
    // eslint-disable-next-line vue/require-default-prop
    eggAnswer: Boolean,
    // eslint-disable-next-line vue/require-default-prop
    eggId: String,
    // eslint-disable-next-line vue/require-default-prop
    bunnyId: String,
  },
  data: () => ({
    animations: {
      animationCurrentState: false,
      animationPlayState: 'animation-play-state: paused;',
    },
    concat: '',
    render: 0,
  }),
  computed: {
    ...mapGetters({
      bannerCorrectStatus: 'easterEgg/bannerCorrectStatus',
      bannerIncorrectStatus: 'easterEgg/bannerIncorrectStatus',
      currentLives: 'easterEgg/currentLives',
      eggAnimationStatus: 'easterEgg/eggAnimationStatus',
      exerciseCompleted: 'easterEgg/exerciseCompleted',
      playerScore: 'easterEgg/playerScore',
    }),
  },
  methods: {
    ...mapActions({ addAnswerPoints: 'easterEgg/addAnswerPoints' }),
    eggEvent(answer) {
      // To change the state of the animation in src/store.js
      if (this.$store.state.easterEgg.exercisePrevent) {
        console.log('Method unavailable. (this.$store.state.easterEgg.exercisePrevent)');
      } else {
        this.$store.state.easterEgg.exercisePrevent = true;
        const animationFunction = () => {
          sounds.easterEggBunnySlide.play();
          this.$store.state.easterEgg.eggAnimationStatus = !this.$store.state.easterEgg.eggAnimationStatus;
          // Bunny Animation
          const lottieBunny = lottie.loadAnimation({
            container: document.getElementById(this.bunnyId),
            renderer: 'svg',
            loop: false,
            autoplay: true,
            path: '/assets/practices/easter_egg/animations/bunny_string.json',
          });
          lottieBunny.setSpeed(1.75);
          // End Bunny Animation
          this.animations.animationPlayState = 'animation-play-state: running;';
          setTimeout(() => {
            if (answer) {
              sounds.easterEggCorrectEgg.play();
              this.concat = '_happy';
              this.$confetti.start({
                defaultSize: 10,
                particlesPerFrame: 0.15,
                particles: [
                  {
                    type: 'rect',
                  },
                  {
                    type: 'circle',
                  },
                  {
                    type: 'image',
                    size: 70,
                    url: '/assets/practices/global/confetti/correct_rock.svg',
                  },
                ],
              });
            } else {
              sounds.easterEggIncorrectEgg.play();
              this.concat = '_sad';
              this.$confetti.start({
                defaultSize: 10,
                particlesPerFrame: 0.1,
                defaultDropRate: 10,
                particles: [
                  {
                    type: 'image',
                    size: 20,
                    dropRate: 5,
                    url: '/assets/practices/global/confetti/incorrect_cross_heavy.svg',
                  },
                  // {
                  //   type: 'image',
                  //   size: 80,
                  //   url: '/assets/practices/global/confetti/incorrect_sad.svg',
                  // },
                ],
              });
            }
          }, 2500);
          setTimeout(() => {
            sounds.easterEggWindBannerIn.play();
          }, 3250);
          setTimeout(() => {
            sounds.easterEggWindBannerOut.play();
          }, 7250);
          this.$store.state.easterEgg.bannerQuestionStatus = false;
          setTimeout(() => {
            this.animations.animationPlayState = 'animation-play-state: paused;';
            this.$store.state.easterEgg.eggAnimationStatus = !this.$store.state.easterEgg.eggAnimationStatus;
            this.concat = '';
            this.render += 1;
          }, 8000);
        };

        // Check for animations currently running to prevent them from running at the same time.
        if (this.$store.state.easterEgg.eggAnimationStatus === false) {
          if (this.$store.state.easterEgg.currentLives >= 1) {
            if (answer) {
              animationFunction();
              sounds.easterEggCorrectAnswer.play();
              this.addAnswerPoints();
              setTimeout(() => {
                this.$store.state.easterEgg.bannerCorrectStatus = true;
                setTimeout(() => {
                  this.$store.state.easterEgg.bannerCorrectStatus = false;
                  this.$store.state.easterEgg.exerciseCompleted = true;
                  if (
                    this.$store.state.easterEgg.exerciseCompleted &&
                    this.$store.state.easterEgg.currentExercise >= 4
                  ) {
                    this.$store.state.easterEgg.gameCompleted = true;
                    this.$confetti.stop();
                  }
                }, 5000);
              }, 3000);
            } else {
              animationFunction();
              sounds.easterEggIncorrectAnswer.play();
              this.$store.state.easterEgg.currentLives -= 1;
              setTimeout(() => {
                this.$store.state.easterEgg.bannerIncorrectStatus = true;
                setTimeout(() => {
                  this.$store.state.easterEgg.explanationMessageStatus = true;
                  this.$store.state.easterEgg.bannerIncorrectStatus = false;
                }, 5000);
              }, 3000);
            }
          }
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/main.scss';

@mixin flex {
  display: flex;
  justify-content: center;
}

.main {
  @include flex;
  align-items: flex-end;
  position: relative;

  #my-canvas {
    height: 100vh;
    position: absolute;
    width: 100vw;
    z-index: -1;
  }

  #bunny0,
  #bunny1,
  #bunny2,
  #bunny3 {
    position: absolute;
    animation: bunny-animation 7s forwards;
    width: 125%;
    left: 0.25vh;
    z-index: 500;
  }

  #egg0,
  #egg1,
  #egg2,
  #egg3 {
    animation: egg-animation 7s forwards;
    position: absolute;
    width: 27vw;
    height: 27vw;
    bottom: -120px;
  }

  .egg {
    @include flex;
    align-items: flex-end;
    position: relative;
    width: 14vw;
  }

  .egg-animation {
    animation: egg-animation 7s forwards;
  }

  .number {
    @include flex;
    position: absolute;
    border: 0.75vw solid black;
    background: white;
    height: 6vw;
    width: 6vw;
    font-size: 3.75vw;
    align-items: center;
  }
}

// Keyframes

@keyframes bunny-animation {
  0% {
    transform: translateY(-150vh);
  }

  20% {
    transform: translateY(-26vh);
  }

  50% {
    transform: translateY(-26vh);
  }

  75% {
    transform: translateY(-150vh);
  }

  100% {
    transform: translateY(-150vh);
  }
}

@keyframes egg-animation {
  0% {
    transform: translateY(0px);
  }

  20% {
    transform: translateY(0px);
  }

  50% {
    transform: translateY(0vh);
  }

  75% {
    transform: translateY(-130vh);
  }

  100% {
    transform: translateY(-130vh);
  }
}

@media (max-device-aspect-ratio: 8/5) {
  @keyframes bunny-animation {
    0% {
      transform: translateY(-150vh);
    }

    25% {
      transform: translateY(-17.5vh);
    }

    35% {
      transform: translateY(-17.5vh);
    }

    100% {
      transform: translateY(-150vh);
    }
  }

  @keyframes egg-animation {
    0% {
      transform: translateY(0px);
    }

    25% {
      transform: translateY(0px);
    }

    35% {
      transform: translateY(0px);
    }

    100% {
      transform: translateY(-130vh);
    }
  }
}
</style>
